export default __webpack_public_path__ + "static/media/background.43b09434.svg";